<template>
  <div class="animated revealUp">
    <div class="d-flex justify-content-between align-item-center mb-3">
      <div class="section-title">
        {{ $t("view") }} {{ $tc("rawmaterials", 2) }}
      </div>
      <div>
        <router-link
          v-if="$can('update', 'Raw Material')"
          class="btn-blue"
          :to="'edit-raw-material/?rm_id=' + rm_id"
          >{{ $t("edit") }}</router-link
        >
        <router-link class="btn-blue" to="raw-materials"
          >{{ $tc("rawmaterials", 2) }} {{ $tc("list", 2) }}</router-link
        >
      </div>
    </div>

    <div class="all-details-container">
      <div class="col-md-12">
        <div class="row">
          <div class="col-md-12 py-2 border-bottom">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">
                {{ $tc("rawmaterials", 1) }}
              </div>
              <div class="col-md-9 col-lg-10 col-xl-10">{{ rm_name }}</div>
            </div>
          </div>

          <div class="col-md-12 py-2 border-bottom">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">{{ $t("recco") }}</div>
              <div class="col-md-9 col-lg-10 col-xl-10">{{ recco }}</div>
            </div>
          </div>

          <!-- rm_code -->
          <div class="col-md-12 py-2 border-bottom">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">{{ $t("code") }}</div>
              <div class="col-md-9 col-lg-10 col-xl-10">{{ rm_code }}</div>
            </div>
          </div>

          <div class="col-md-12 py-2 border-bottom">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">
                {{ $tc("rawmaterials", 1) }} {{ $tc("category", 1) }}
              </div>
              <div class="col-md-9 col-lg-10 col-xl-10">{{ rmc_label }}</div>
            </div>
          </div>

          <div class="col-md-12 py-2 border-bottom">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">
                {{ $t("description") }}
              </div>
              <div class="col-md-9 col-lg-10 col-xl-10">
                {{ rm_description }}
              </div>
            </div>
          </div>

          <div class="col-md-12 py-2 border-bottom">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">
                {{ $t("stock") }} {{ $t("alert") }}
              </div>
              <div class="col-md-9 col-lg-10 col-xl-10">
                {{ stock_alert_quantity_threshold }}
              </div>
            </div>
          </div>

          <div class="col-md-12 py-2 border-bottom">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">
                {{ $tc("unitofmeasurement", 2) }}
              </div>
              <div class="col-md-9 col-lg-10 col-xl-10">
                {{ uom_id_threshold_label }}
              </div>
            </div>
          </div>

          <div class="col-md-12 py-2 border-bottom">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">
                {{ $t("isExpiryavailable") }}
              </div>
              <div
                v-if="is_expiry_available == 'Y'"
                class="col-md-9 col-lg-10 col-xl-10"
              >
                {{ $t("yes") }}
              </div>
              <div v-else class="col-md-9 col-lg-10 col-xl-10">
                {{ $t("no") }}
              </div>
            </div>
          </div>

          <div class="col-md-12 py-2 border-bottom">
            <div class="row">
              <div class="col-md-3 col-lg-2 col-xl-2">
                {{ $tc("status", 1) }}
              </div>
              <div
                v-if="rm_is_active == 'Y'"
                class="col-md-9 col-lg-10 col-xl-10"
              >
                {{ $t("active") }}
              </div>
              <div v-else class="col-md-9 col-lg-10 col-xl-10">
                {{ $t("inactive") }}
              </div>
            </div>
          </div>

          <div class="col-12" v-if="GetRoleId && GetRoleId === 1">
            <div class="row">
              <div class="col-md-12 py-2 border-bottom">
                <div class="row">
                  <div class="col-md-3 col-lg-2 col-xl-2">
                    {{ $t("createdby") }}
                  </div>
                  <div class="col-md-9 col-lg-10 col-xl-10">
                    <span>{{ created_by }}</span>
                  </div>
                </div>
              </div>

              <div class="col-md-12 py-2 border-bottom">
                <div class="row">
                  <div class="col-md-3 col-lg-2 col-xl-2">
                    {{ $t("createdat") }}
                  </div>
                  <div class="col-md-9 col-lg-10 col-xl-10">
                    <span class="mr-3">{{ created_at | dateparse }}</span>
                    <!-- <span>12:05 AM</span> -->
                  </div>
                </div>
              </div>

              <div class="col-md-12 py-2 border-bottom">
                <div class="row">
                  <div class="col-md-3 col-lg-2 col-xl-2">
                    {{ $t("modifiedby") }}
                  </div>
                  <div class="col-md-9 col-lg-10 col-xl-10">
                    <span>{{ updated_by }}</span>
                  </div>
                </div>
              </div>

              <div class="col-md-12 py-2">
                <div class="row">
                  <div class="col-md-3 col-lg-2 col-xl-2">
                    {{ $t("modifiedat") }}
                  </div>
                  <div class="col-md-9 col-lg-10 col-xl-10">
                    <span class="mr-3">{{ updated_at | dateparse }}</span>
                    <!-- <span>12:05 AM</span> -->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Multiselect from "vue-multiselect";
import MasterService from "@/services/MasterService";
import PosFnbService from "@/services/PosFnbService";
export default {
  components: { Multiselect },
  data() {
    return {
      rm_name: "",
      rm_code: "",
      rm_rte: true,
      rmc_label: "",
      recco: false,
      is_expiry_available: false,
      validStatus: false,
      rm_description: "",
      stock_alert_quantity_threshold: "",
      uom_id_threshold: "Select Value",
      rm_is_perishable: false,
      rm_is_active: true,
      selected: null,
      uom_id_threshold_label: "",
      units_of_measurements: [],
      rm_id: "",
      created_at: "",
      created_by: "",
      updated_by: "",
      updated_at: "",
    };
  },
  beforeMount() {
    this.rm_id = this.$route.query.rm_id;
  },
  mounted() {
    this.getRawMaterialDetails();
  },
  methods: {
    getunitofmeasurements: function (obj) {
      let payload = {
        tableName: "ms_unit_of_measurement",
        uom_is_active: "Y",
      };
      MasterService.GetActiveList(payload)
        .then((response) => {
          const { data } = response;
          if (data && data.status) {
            this.units_of_measurements = data.Records;
            this.units_of_measurements.map((x) => {
              // console.log("obj :", obj.uom_id_threshold, x.uom_id);
              if (obj.uom_id_threshold == x.uom_id) {
                this.uom_id_threshold_label = x.uom_unit;
              }
            });
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError); //message
    },
    getRawMaterialDetails: function () {
      let payload = {
        tableName: "ms_raw_materials",
        rm_id: this.rm_id,
      };
      MasterService.GetActiveList(payload)
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            let obj = data.Records[0];
            this.rm_name = obj.rm_name;
            this.rm_code = obj.rm_code;
            this.rm_rte = obj.rm_rte;
            this.recco = obj.recco;
            this.is_expiry_available = obj.is_expiry_available;
            this.getRawMaterialCategoryList(obj.rmc_id);
            this.rm_description = obj.rm_description;
            this.validStatus = true;
            this.stock_alert_quantity_threshold =
              obj.stock_alert_quantity_threshold;
            console.log(
              "this.stock_alert_quantity_threshold :",
              this.stock_alert_quantity_threshold
            );
            this.rm_is_perishable = obj.rm_is_perishable;
            this.rm_is_active = obj.rm_is_active;
            this.created_at = obj.created_at;
            this.updated_at = obj.updated_at;
            Object.keys(obj).map((x) => {
              if (x === "created_by") {
                this.getViewUsersDetails(obj[x], "created_by");
              } else if (x === "updated_by") {
                this.getViewUsersDetails(obj[x], "updated_by");
              }
            });
            this.getunitofmeasurements(obj);
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError); //message
    },
    getRawMaterialCategoryList: function (rmc_id) {
      let payload = {
        tableName: "ms_raw_material_category",
      };
      MasterService.GetActiveList(payload)
        .then((response) => {
          const { data } = response;
          if (data && data.status && data.Records.length > 0) {
            data.Records.map((x) => {
              if (x.rmc_id == rmc_id) {
                this.rmc_label = x.rmc_category;
              }
            });
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError); //message
    },
    getViewUsersDetails(user_id, fieldvalue) {
      if (user_id) {
        MasterService.GetUserInfoById({ user_id })
          .then((response) => {
            const { data } = response;
            if (data && data.status && data.Records.length > 0) {
              this[fieldvalue] = data.Records[0].user_name;
            } else {
              this.$toasted.show(data.message);
            }
          })
          .catch(this._CatchError); //message
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Pages/FoodAndBeveragesContainer/RawMaterialsComponents/viewRawMaterial.vue